import { render, staticRenderFns } from "./AppOverviewDeclarationCorrections.vue?vue&type=template&id=d1c1d52c&scoped=true&"
import script from "./AppOverviewDeclarationCorrections.vue?vue&type=script&lang=ts&"
export * from "./AppOverviewDeclarationCorrections.vue?vue&type=script&lang=ts&"
import style0 from "./AppOverviewDeclarationCorrections.vue?vue&type=style&index=0&id=d1c1d52c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c1d52c",
  null
  
)

export default component.exports